module.exports = __webpack_public_path__ + "img/3-1.faa5be7d.svg";